module.exports = __webpack_public_path__ + "img/enterprise-introduction.35b407a6.png";